import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import { useEffect } from "react";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import ProjectList from "./pages/projectList";
import Contacts from "./pages/contacts";
import Designer from "./pages/Designer";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Furnitures from "./pages/furnitures";
import ProjectsCardShow from "./components/ProjectsCardShow";

// Wrapper to access `location.pathname`
function LayoutWrapper() {
  const location = useLocation();

  // ✅ Add pages where you want the Navbar to show
  const showNavbar = [
    "/",
    "/about",
    "/projects",
    "/contacts",
    "/designer",
    "/furnitures",
  ].includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      {showNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/projects" element={<ProjectList />} />
        <Route path="/designer" element={<Designer />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/furnitures" element={<Furnitures />} />

        {/* Add other routes */}
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <LayoutWrapper />
    </Router>
  );
}
